import React from 'react'
import { useParams } from 'react-router-dom'
import SearchComponent from '../components/Sidebar/Search'
import RequestPopupComponent from '../components/Sidebar/RequestPopup'
import ThemePopupComponent from '../components/Sidebar/ThemePopup'
import EditPopupComponent from '../components/Sidebar/EditPopup'
import DeletePopupComponent from '../components/Sidebar/deletepopup'
import TaskComponent from '../components/Sidebar/Task'
import ProjectTaskComponent from '../components/Sidebar/ProjectTask'
import TaskDatailComponent from '../components/Sidebar/TaskDatail'
import TaskCardSComponent from '../components/Sidebar/TaskCardS'
import { useSelector } from 'react-redux'

export default function Popups() {
  const active = useSelector((state) => state.popupState.activePanel)
  const projectId = useSelector((state) => state.popupState.projectId)
  const { id } = useParams()

  // projectId'yi store'dan veya URL'den al
  const currentProjectId = projectId || id

  return (
    <React.Fragment>
      {active[0] == 9 && <SearchComponent />}
      {active[0] == 1 && <RequestPopupComponent />}
      {active[0] == 2 && <ThemePopupComponent />}
      {active[0] == 3 && <EditPopupComponent />}
      {active[0] == 4 && <DeletePopupComponent />}
      {active[0] == 5 && <TaskComponent type={active[1]} />}
      {active[0] == 6 && <ProjectTaskComponent type={active[1]} projectId={currentProjectId} taskId={active[2]} />}
      {active[0] == 7 && <TaskDatailComponent />}
      {active[0] == 8 && <TaskCardSComponent />}
    </React.Fragment>
  )
}
